<template>
  <div>
    <PageHeader
      :page="page"
      has-return
      left-side-class="col-xl-8"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />   
    <div v-if="historyResult.length">
      <TimeLine class="mt-4 mx-3">
        <TimeLineItem
          v-for="(row, index) in historyResult"
          :key="index"
          class="custom-time-line rounded"
        >
          <template #icon>
            <em class="color-white fa-exchange far radius" />
          </template>
          <template #date>
            <div class="date-container">
              <div class="color-black font-16 font-weight-bold fulldate">
                {{ formatter(row.date) | date }}
                <small>{{ formatter(row.date) | hour }}</small>
              </div>
            </div>
          </template>
          <div class="row">
            <div class="col-12 col-md-2 flex-column d-flex border-right">
              <label class="mb-0 px-2 pt-1 font-weight-bold">
                Cambio de Estatus
              </label>
            </div>
            <div
              class="d-none d-md-block col-md-1 border-left--color-gray vertical-line"
            />
            <div class="col-12 col-md-3 mt-2 flex-column d-flex">
              <label class="mb-0 color-gray-6 text-small">Usuario:</label>
              <span class="info-text">{{ row.userRole }}</span>
            </div>
            <div class="col-12 col-md-3 mt-2 flex-column d-flex">
              <label class="mb-0 color-gray-6 text-small">Nombre:</label>
              <span class="info-text">{{ row.user }}</span>
            </div>
            <div class="col-12 col-md-3 mt-2 flex-column d-flex">
              <label class="mb-0 color-gray-6 text-small">Estatus:</label>
              <span class="d-flex align-items-baseline">
                <em
                  class="fa fa-circle pr-2"
                  :style="`color: ${row.statusColor}`"
                />
                <span class="info-text">{{ row.status }}</span>
              </span>
            </div>
            <div class="col-12 mt-3">
              <div class="bg-white rounded py-3 px-4">
                <div class="mb-0 color-gray-6 text-small">
                  <span class="fas fa-info-circle color-orange pr-1" />
                  Descripción:
                </div>
                <div class="color-black font-16 mt-2">{{ row.reason }}</div>
              </div>
            </div>
          </div>
        </TimeLineItem>
      </TimeLine>    
    </div>
    <div v-else>
      <CustomResultNotFound text="No hay información disponible." />
    </div>   
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import PageHeader from 'PageHeader';
import CustomResultNotFound from 'custom-result-not-found';
import { getRequestStatusColor } from '@/utils/constants/hrrequest/requestStatusCodes';
import { getRequestHistory } from '@/modules/human-resources/api';
import moment from 'moment';

export default {
  name: 'RequestHistory',
  components: {
    TimeLine,
    TimeLineItem,
    PageHeader,
    CustomResultNotFound
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Historial de la solicitud',
        routes: ['Inicio', 'Solicitud de Personal Irregular'],
      },
      requestId: null,   
      historyResult: []   
    };
  },
  computed: {         
  },
  methods: {
    async fetchResources() {    
      await getRequestHistory(this.requestId).then((res) => {
        this.historyResult = res.data;        
      });
    },   
    formatter(date) {
      return moment(date);
    },
  },
  async mounted() {
    if (!this.$route.params.id || isNaN(this.$route.params.id))
      this.$router.push(`/humanres/request`);
    else {
      this.requestId = parseInt(this.$route.params.id);
      this.fetchResources();
    }
  },
};
</script>

<style></style>
